import { Analytics, AnalyticsPlugin, Appcues, LogRocket, Segment, Userflows } from '@cheqroom/analytics';

const Client = new Analytics(
	[
		process.env.SEGMENT_KEY &&
			new Segment({ apiHost: process.env.SEGMENT_API as string, apiKey: process.env.SEGMENT_KEY }),
		process.env.APPCUES_ID && new Appcues({ appcuesId: process.env.APPCUES_ID }),
		process.env.USERFLOWS_ID && new Userflows({ userflowToken: process.env.USERFLOWS_ID }),
		process.env.LOGROCKET_APP_ID &&
			new LogRocket({ token: process.env.LOGROCKET_APP_ID, release: process.env.BUILD_VERSION }),
	].filter(Boolean) as AnalyticsPlugin[]
);

export default Client;
